import { useState } from "react";
import { useQuery } from "react-query";
import { api } from "service";

export default function usePopup() {
  const [list, setList] = useState([]);
  const getPopup = useQuery(
    ["popup"],
    () => {
      return api.popup.getPopup().then((res) => {
        setList(res.data || []);
      });
    },
    {
      refetchOnWindowFocus: false,
    }
  );

  return { getPopup, list };
}
